"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginResponseDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const Account_dto_1 = require("./Account.dto");
const UserMinimal_dto_1 = require("./UserMinimal.dto");
class LoginResponseDto {}
exports.LoginResponseDto = LoginResponseDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], LoginResponseDto.prototype, "token", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], LoginResponseDto.prototype, "grantedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], LoginResponseDto.prototype, "expiresAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => Account_dto_1.AccountDto
}), __metadata("design:type", Account_dto_1.AccountDto)], LoginResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => UserMinimal_dto_1.UserMinimalDto,
  nullable: true
}), __metadata("design:type", Object)], LoginResponseDto.prototype, "user", void 0);
//# sourceMappingURL=LoginResponse.dto.js.map